export function useAuth() {
  const user = useSupabaseUser()
  const supabase = useSupabaseClient()

  const isAdmin = computed(() => {
    const meta = (user.value as any)?.app_metadata
    return meta?.role === 'admin'
  })

  const displayName = computed(() => {
    const u = user.value as any
    if (!u) return ''
    const meta = u.user_metadata ?? {}
    return meta.full_name || meta.name || (u.email ? String(u.email).split('@')[0] : 'Account')
  })

  async function signOut() {
    await supabase.auth.signOut()
    await navigateTo('/')
  }

  return { user, isAdmin, displayName, signOut }
}
